import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/geofences/new')({
  // Creating a geofence now happens inside a geoset (`/geofences/:geosetId/new`),
  // which this legacy link can't target — send it to the geosets index instead.
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geosets',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
